<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label class="required">供应商</label>
            </div>
            <div class="form-value ">
                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsWrntExtVoucher.sellerName"></el-input>
                <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" v-if="show" @click="showVendorDlg();"></i>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>资产信息</span>
            <span class="fr font12" v-if="goodsWrntExtVoucher.goodsWrntExtItems != null">已选择({{
                goodsWrntExtVoucher.goodsWrntExtItems.length
                }})</span>
        </div>
        <div class="simple-row">
            <div class="left" v-if="goodsWrntExtVoucher.sellerId != null && show">
                <button class="swb-btn swb-btn-small" @click="showDeviceListDlg()">
                    <span>选择</span>
                </button>
            </div>
            <div class="right" v-if="goodsWrntExtVoucher.sellerId != null && show">
                <button class="swb-btn swb-btn-small" @click="batchGoodsWrntExtDlg()">
                    <span>批量延保</span>
                </button>
            </div>
        </div>
        <div class="table-layout">
            <div style="width: 100%;overflow-x: auto">
                <el-form :model="goodsWrntExtVoucher" ref="goodsWrntExtVoucher" :rules="rules">
                    <el-table :data="goodsWrntExtVoucher.goodsWrntExtItems" border @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                        <el-table-column prop="title" width="180" label="资产描述全称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" width="180" label="名称" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerBizUnitName" width="180" label="业务单元" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="retailerShopName" width="180" label="所属部门" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="model" width="150" label="型号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fixedSpec" width="150" label="规格" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tmpNo" width="250" label="系统编号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="ukNo" width="250" label="标识码" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="catName" width="100" label="分类" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="brandName" width="120" label="品牌" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="batchNo" width="160" label="批次号" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="price" width="130" label="原值（元）" align="right" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="recvDate" width="180" label="资产收货日期" align="left" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="wrntDueDateOld" width="180" label="原质保到期日" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <el-date-picker disabled style="width: 100%" v-model="rows.row.wrntDueDateOld" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="show" prop="wrntPeriod" width="120" label="延保时长（月）" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <el-input class="input-content-left" :id="'wrntPeriod'+rows.$index" type="text" v-model="rows.row.wrntPeriod" @change="changeWrntDueDateNew(rows.row, rows.$index);"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wrntDueDateNew" width="180" label="新质保到期日" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <el-form-item :prop="'goodsWrntExtItems.' + rows.$index + '.wrntDueDateNew'" :rules="rules.validateFee">
                                    <el-date-picker :disabled="!show" style="width: 100%" v-model="rows.row.wrntDueDateNew" type="datetime" format="yyyy-MM-dd" @change="clearWrntPeriod(rows.$index);" placeholder="选择日期"></el-date-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fee" width="120" label="延保费用" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <el-form-item :prop="'goodsWrntExtItems.' + rows.$index + '.fee'" :rules="rules.validateFee">
                                    <el-input :disabled="!show" class="input-content-left" type="text" v-model="rows.row.fee"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="show" align="center" width="80" label="操作" show-overflow-tooltip fixed="right">
                            <template slot-scope="rows">
                                <a class="swb-btn-link" v-if="show" @click="deleteDevice(rows.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import { showAssetSelectDlg } from "../retailer/selectDlg";
    import{ showDevcSelectDlg } from '../devc/selectDlg'
    import goodsWrntApi from "../../api/goodsWrnt";

    export default {
        name: "swb-goods-wrnt-ext-voucher-save",
        desc: '商品售后延保保存',
        props: {
            id: {
                type: Number,
                default: null
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                goodsWrntExtVoucher: {
                    goodsWrntExtItems: [],
                    sellerId: null,
                    sellerType: null,
                    sellerName: null,
                    sellerRealId: null,
                },
                rules: {
                    validateFee: [
                        {required: true, message: "不可为空", trigger: "blur"}
                    ],
                },
                multipleSelection: []
            }
        },
        created: function () {
            let self = this;
            if(!Utils.isNoB(self.id)) {
                goodsWrntApi.getGoodsWrntExtVoucher(self.id, function (result) {
                    if(result.type === "info") {
                        self.goodsWrntExtVoucher = Utils.merge({}, result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        methods: {
            showVendorDlg: function () {
                let self = this;
                let params = {
                    multiSelect: false,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: true, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 卖方关联，备选其他
                    showNoScoreBizRel: true, // 待入围
                    showShieldedBizRel: true, // 加黑
                    showAll: true // 全部
                };
                // 选择供应商
                openVendorSelectComnDlg(self, params, function (result) {
                    let resultData = result.checkedList;
                    self.setSelectMerchtInfo(resultData);
                });
            },
            setSelectMerchtInfo: function (object) {
                let self = this;
                //
                console.log(object);
                self.goodsWrntExtVoucher.sellerId = object.id;
                self.goodsWrntExtVoucher.sellerName = object.name;
                self.goodsWrntExtVoucher.sellerRealId = object.realId;

                self.goodsWrntExtVoucher = Utils.merge({}, self.goodsWrntExtVoucher);
            },
            // 移除普通设备
            deleteDevice: function (index) {
                let goodsWrntExtItems = this.goodsWrntExtVoucher.goodsWrntExtItems || [];
                for(let i = 0; i < goodsWrntExtItems.length; i++) {
                    if(i == index) {
                        goodsWrntExtItems.splice(i, 1);
                        break;
                    }
                }
                this.goodsWrntExtVoucher.goodsWrntExtItems = Utils.merge([], goodsWrntExtItems);
            },
            showDeviceListDlg: function () {
                let self = this;
                let sellerId = self.goodsWrntExtVoucher.sellerId;

                let dlgConfig = {
                    filter: {
                        sellerId: sellerId,
                    },
                    initSelectIds: [],
                    showOrgTree: true,
                    bizDepart: true,
                };
                showDevcSelectDlg(dlgConfig, function (deviceList) {
                    let singleDeviceList = Utils.merge([], deviceList);
                    let goodsWrntExtItems = self.goodsWrntExtVoucher.goodsWrntExtItems;
                    singleDeviceList.forEach(function (singleDevice) {
                        let goodsWrntExtItem = {};
                        goodsWrntExtItem.devcId = singleDevice.id;
                        goodsWrntExtItem.tmpNo = singleDevice.tmpNo;
                        goodsWrntExtItem.batchNo = singleDevice.batchNo;
                        goodsWrntExtItem.recvDate = singleDevice.receiveTime;
                        goodsWrntExtItem.wrntDueDateOld = singleDevice.wrntDueTime;
                        goodsWrntExtItem.catName = singleDevice.catName;
                        goodsWrntExtItem.brandName = singleDevice.brandName;
                        goodsWrntExtItem.catId = singleDevice.catId;
                        goodsWrntExtItem.brandId = singleDevice.brandId;
                        goodsWrntExtItem.name = singleDevice.name;
                        goodsWrntExtItem.model = singleDevice.model;
                        goodsWrntExtItem.ukNo = singleDevice.vendorUkno;
                        goodsWrntExtItem.fixedSpec = singleDevice.fixedSpec;
                        goodsWrntExtItem.modelSpec = singleDevice.modelSpec;
                        goodsWrntExtItem.title = singleDevice.title;
                        goodsWrntExtItem.price = singleDevice.orgWorth;
                        goodsWrntExtItem.skuId = singleDevice.skuId;
                        goodsWrntExtItem.goodsId = singleDevice.goodsId;
                        goodsWrntExtItem.fee = null;
                        goodsWrntExtItem.retailerShopName = singleDevice.retailerShopName;
                        goodsWrntExtItem.retailerBizUnitName = singleDevice.retailerBizUnitName;
                        goodsWrntExtItems.push(goodsWrntExtItem);
                    });
                    self.goodsWrntExtVoucher.goodsWrntExtItems = Utils.merge([], goodsWrntExtItems);
                });
            },
            changeWrntDueDateNew: function (goodsWrntExtItem, index) {
                let wrntPeriod = goodsWrntExtItem.wrntPeriod;
                let goodsWrntExtItems = this.goodsWrntExtVoucher.goodsWrntExtItems;
                if(wrntPeriod > 0) {
                    goodsWrntExtItems[index].wrntPeriod = goodsWrntExtItem.wrntPeriod;
                    let currentTime = new Date();
                    if(currentTime.diff(new Date(goodsWrntExtItems[index].wrntDueDateOld)) > 0) {
                        currentTime = currentTime.addMonths(goodsWrntExtItem.wrntPeriod);
                    } else {
                        currentTime = new Date(goodsWrntExtItems[index].wrntDueDateOld).addMonths(goodsWrntExtItem.wrntPeriod);
                    }
                    goodsWrntExtItems[index].wrntDueDateNew = currentTime.format('yyyy-MM-dd');
                } else {
                    goodsWrntExtItems[index].wrntDueDateNew = null;
                }
                this.goodsWrntExtVoucher.goodsWrntExtItems = Utils.merge([], goodsWrntExtItems);
                this.$forceUpdate();
            },
            clearWrntPeriod: function (index) {
                let goodsWrntExtItems = this.goodsWrntExtVoucher.goodsWrntExtItems;
                goodsWrntExtItems[index].wrntPeriod = null;
                this.goodsWrntExtVoucher.goodsWrntExtItems = Utils.merge([], goodsWrntExtItems);
                this.$forceUpdate();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            batchGoodsWrntExtDlg: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '批量延保',
                    showCloseBtn: true,
                    width: 600,
                    height: 500,
                    template: '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>延保时长（月）</label>' +
                    '        </div>' +
                    '        <div class="form-value width-1-5x">' +
                    '            <el-input class="align-right" type="number" v-model="wrntPeriod"></el-input>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>新质保到期日</label>' +
                    '        </div>' +
                    '        <div class="form-value width-1-5x">' +
                    '            <el-date-picker v-model="wrntDueDateNew" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>延保费用</label>' +
                    '        </div>' +
                    '        <div class="form-value width-1-5x">' +
                    '            <el-input class="align-right" type="number" v-model="fee"></el-input>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>',
                    data: {
                        wrntPeriod: null,
                        wrntDueDateNew: null,
                        fee: null
                    },
                    methods: {},
                    okClicked: function () {
                        let thisSelf = this;
                        let goodsWrntExtItems = self.goodsWrntExtVoucher.goodsWrntExtItems;
                        self.multipleSelection.forEach(function (item) {
                            goodsWrntExtItems.forEach(function (goodsWrntExtItem) {
                                if(thisSelf.wrntDueDateNew != null && item.devcId == goodsWrntExtItem.devcId) {
                                    if(new Date(thisSelf.wrntDueDateNew).diff(new Date(item.wrntDueDateOld)) < 0) {
                                        MsgBox.warning('存在新质保时间小于原质保时间');
                                        return false;
                                    } else {
                                        goodsWrntExtItem.wrntDueDateNew = thisSelf.wrntDueDateNew;
                                    }
                                } else if(thisSelf.wrntPeriod != null && thisSelf.wrntPeriod > 0 && item.devcId == goodsWrntExtItem.devcId) {
                                    let currentTime = new Date();
                                    if(currentTime.diff(new Date(item.wrntDueDateOld)) > 0) {
                                        goodsWrntExtItem.wrntDueDateNew = currentTime.addMonths(thisSelf.wrntPeriod);
                                    } else {
                                        goodsWrntExtItem.wrntDueDateNew = new Date(item.wrntDueDateOld).addMonths(thisSelf.wrntPeriod);
                                    }
                                    goodsWrntExtItem.wrntPeriod = thisSelf.wrntPeriod;
                                }
                                goodsWrntExtItem.fee = thisSelf.fee;
                            });
                        });
                        self.goodsWrntExtVoucher.goodsWrntExtItems = Utils.merge([], goodsWrntExtItems);
                        return true;
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['goodsWrntExtVoucher'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.goodsWrntExtVoucher;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/compo/order/GoodsWrntExtVoucherSave.vue